import * as React from 'react';
import highlightDisplayText from '../../../utils/highlightDisplayText';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { observer } from 'mobx-react-lite';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { SMALL_SUGGESTION_HEIGHT } from '../../../searchConstants';
import { SubstrateSearchSuggestionPersonSegment } from 'owa-search-service';

const searchSuggestionStyles = require('../SearchSuggestion.scss');
const styles = require('./PeopleSegment.scss');

export interface PeopleSegmentProps {
    segment: SubstrateSearchSuggestionPersonSegment;
}

export const PeopleSegment = observer(function PeopleSegment(props: PeopleSegmentProps) {
    const { segment } = props;

    const hitHighlightedDisplayText = highlightDisplayText(segment.DisplayText)
        .filter(e => e.text.length > 0)
        .map((e, i) => (
            <div
                key={i}
                className={
                    e.isHighlighted
                        ? searchSuggestionStyles.keywordMatchSuggestion
                        : searchSuggestionStyles.keywordNonMatchSuggestion
                }>
                {e.text}
            </div>
        ));

    const style: React.CSSProperties = {
        lineHeight: `${SMALL_SUGGESTION_HEIGHT}px`,
    };

    return (
        <div className={styles.container} style={style}>
            <PersonaControl
                emailAddress={segment.EmailAddress}
                name={segment.DisplayName}
                size={PersonaSize.size28}
            />
            <div className={styles.personName} title={segment.DisplayName}>
                {hitHighlightedDisplayText}
            </div>
        </div>
    );
});
